import type { AppRequestRoute } from './types'

const routes: Record<AppRequestRoute, string> = {
  'hiring.tutor.tracking': '/api/hiring/tutor',
}

export default routes
